import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React from "react";

// when using useHover <T> gets passed as the argument
//https://stackoverflow.com/questions/57201223/typescript-how-to-declare-a-type-that-includes-all-types-extending-a-common-typ

export default function useHover() {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  var ref = React.useRef(null);
  var handleMouseOver = function handleMouseOver() {
    return setValue(true);
  };
  var handleMouseOut = function handleMouseOut() {
    return setValue(false);
  };
  React.useEffect(function () {
    var node = ref.current;
    if (node) {
      node.addEventListener("mouseover", handleMouseOver);
      node.addEventListener("mouseout", handleMouseOut);
      return function () {
        node === null || node === void 0 || node.removeEventListener("mouseover", handleMouseOver);
        node === null || node === void 0 || node.removeEventListener("mouseout", handleMouseOut);
      };
    }
  }, [ref.current] // Recall only if ref changes
  );
  return [ref, value];
}